import style from '../Home.module.scss';
import className from 'classnames/bind';
import {Image, StatusLabel} from "../../../components";
import {numberFormat} from "../../../utils";
import FontAwesomeIcon from "~/components/FontAwesome";

const cn = className.bind(style);

const CardRanksDesign = ({name, items, cardColor, bgImage, icon = 'fa-light fa-star'}) => {
	return (
		<div className={cn('card', 'card-ranks', cardColor)}>
			<div style={{display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20}}>
				<div style={{
					width: 34, height: 34, borderRadius: 10,
					background: 'rgba(255,255,255,0.2)',
					display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
				}}>
					<FontAwesomeIcon icon={icon} style={{color: '#fff', fontSize: 18}} />
				</div>
				<h4 className={cn('heading')} style={{margin: 0}}>{name}</h4>
			</div>
			<div className={cn('list-ranks')}>
				{items.map((item) => (
					<div key={`card-rank-${item.id}`} className={cn('user', 'user-white', 'd-flex', 'gap', 'align-items')}>
						<div className={cn('avatar-rank', 'avatar')}><Image src={item.avatar} /></div>
						<div>
							<b className={cn('name')}>{item.firstname} {item.lastname}</b>
							<p className={cn('info-more')}>{item.username}</p>
						</div>
						<div>
							<StatusLabel type="yellow" small>Đa nhận {numberFormat(item.assign)}</StatusLabel>
							<StatusLabel type="green" className="ml-1" small>Hoàn thành {numberFormat(item.success)}</StatusLabel>
						</div>
					</div>
				))}
			</div>
			<div className={cn('bg')}><Image src={bgImage} /></div>
		</div>
	);
};

export default CardRanksDesign;
